
export class Inscricao {
  id: number;
  trabalho_id: number;
  relator: boolean;
  usuario_id: number;
  evento_id: number;
  numero: number;
  perfil_autoria_id: number;
  evento_name: string;
  trabalhos: number;
  teatro: boolean;
  cinema: boolean;
  show: boolean;
  plano_cultura: boolean;
  producao_evento: string;
  espacos_culturais: string;
  avaliacao_edital: string;
  sugestoes_edital: string;
  identidade: File;
  cpf: File;
  crid: File;	
}



// WEBPACK FOOTER //
// ./src/app/inscricao/inscricao.ts